
import { Request } from "./data-service";

export class Api {
	/** Component methods **/
	constructor(){
		this.domain = "http://localhost:8081";
	}

	/** Public methods **/
	get(request){
		return new Promise(resolve => {
			let fetch_url = request.domain + request.url;


			fetch(fetch_url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})
			.catch( (err) => { console.log("err: ", err);})

		})
		.catch( (err) => { console.log("err: ", err);})
		
	}

	post(request){
		return new Promise(resolve => {
			let fetch_url = request.domain + request.url;
			fetch(fetch_url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})
			.catch( (err) => { console.log("err: ", err);})
			
		})
		.catch( (err) => { console.log("err: ", err);})
				
	}

	put(request){
		return new Promise(resolve => {
			let fetch_url = request.domain + request.url;
			fetch(fetch_url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})
			.catch( (err) => { console.log("err: ", err);})
			
		})
		.catch( (err) => { console.log("err: ", err);})
	}// end put

	// DELETE
	remove(request){
		return new Promise(resolve => {
			let fetch_url = request.domain + request.url;
			fetch(fetch_url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})

		})
		.catch( (err) => { console.log("err: ", err);})
	}
}
